const CircleArrowMoveDownLeftIcon = /*#__PURE__*/ [
  ["path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.3738 12.5313C9.86553 13.1616 8.83275 13.9422 9.01659 14.3129M9.01659 14.3129C8.91418 14.6908 9.91412 15.4379 10.3761 16.0078M9.01659 14.3129C11.0994 14.3582 12.3737 14.1062 13.6038 12.8814C14.8849 11.6057 15.0957 10.2118 14.992 8.00317", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { CircleArrowMoveDownLeftIcon as default };
//# sourceMappingURL=CircleArrowMoveDownLeftIcon.js.map
